import { Tab } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../../components/Page/Page';
import { DeputatePersonsTable } from '../../../../components/Persons/Tables/DeputatePersonsTable';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { PersonRole } from '../../../../types/planung-graphql-client-defs';

export const SetupPersons = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <Tab
        variant={'large'}
        tabs={[
          {
            title: t('persons.title', { count: 2 }),
            value: 'teachers',
            content: <DeputatePersonsTable personsRole={PersonRole.Teacher} />,
          },
          {
            title: t('persons.other'),
            value: 'other',
            content: <DeputatePersonsTable personsRole={PersonRole.Other} />,
          },
        ]}
      />
    </Page>
  );
};
